import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import renderHTML from 'react-render-html';
import Link from '../common/TrackedLink';
import TrackedLink from "../common/TrackedLink";

class LinkToStore extends Component {

	handleChange(query) {
		browserHistory.push(`/search?q=${query}&type=product`);
	}


	constructor(props) {
		super(props);

		this.state = {
			keyword: null,
			products: [],
			product: null
		};
	}

	render() {
		const styles = {
			maxWidth: '500px',
			margin: 'auto',
			paddingLeft: '20px',
			paddingRight: '20px'
		};

		return (
			<section className="section section-search-results no-results">
				<Helmet>
					<title>{renderHTML(`Search Results for "${this.props.keyword}" | SentrySafe`)}</title>
				</Helmet>
				<div className="section-content ">
					<div className="text-center" >
						<h1 className="section-title" >
							Sorry, we didn&rsquo;t find any matches for '<b>{this.props.keyword}</b>'.
						</h1>
						<TrackedLink to={this.props.product.url} target='_blank' className='section-subtitle'>
							<h6>Please visit our SentrySafe Store.</h6>
						</TrackedLink>
						<div style={styles}>
							<Link to={this.props.product.url} className="product-img" style={styles} target={this.props.product.target}>
								<div className="product-card-box">
									<img src={this.props.product.image} alt={this.props.product.name} width='200' />
									<h3 className="product-title" >{this.props.product.name}</h3>
								</div>
							</Link>
						</div>
					</div>
				</div >
			</section >
		);
	}
};

export default branch({
	token: ['token']
}, LinkToStore);


// WEBPACK FOOTER //
// ./src/pages/notFound/LinkToStore.js